import { Badge } from '@onefootprint/ui';
import { z } from 'zod';
import { type ArtifactTone, toneSchema, toneStyles } from '../block-tones';
import { inlineChipProps } from '../inline-chip';
import { decodeParams, encodeParams, matchEnvelope } from '../inline-markup-envelope';
import type { InlineKindEntry, InlineRenderCtx, ParsedInline } from '../inline-markup-types';

type PillToken = { kind: 'pill'; tone: ArtifactTone; label: string };

const pillParamsSchema = z.object({ tone: toneSchema, label: z.string().trim().min(1).max(80) });

const parsePill = (text: string): ParsedInline[] => {
  const parsed: ParsedInline[] = [];
  for (const match of matchEnvelope(text)) {
    if (match.kind !== 'pill') continue;
    const result = pillParamsSchema.safeParse(decodeParams(match.rawParams));
    if (!result.success) continue;
    parsed.push({ index: match.index, raw: match.raw, token: { kind: 'pill', ...result.data } });
  }
  return parsed;
};

const serializePill = (token: PillToken): string =>
  `{footprint:pill${encodeParams({ tone: token.tone, label: token.label })}}`;

const renderPillReact = (token: PillToken, ctx: InlineRenderCtx) => (
  <Badge
    {...inlineChipProps(ctx)}
    data-tone={token.tone}
    data-tone-pill="true"
    variant={toneStyles[token.tone].badgeVariant}
  >
    {token.label}
  </Badge>
);

export const pillEntry: InlineKindEntry = {
  marker: '{footprint:',
  parse: parsePill,
  serialize: serializePill,
  renderReact: renderPillReact,
};
